import { defineComponent as _defineComponent } from 'vue'
import InputSearchTextField from '@/components/common/InputSearchTextField.vue';
import AddOnTileItem from './AddOnTileItem.vue';
import { computed, ref } from 'vue';
import { AddOnTile } from './types';

interface TileItemChildrenProps {
	items: AddOnTile[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TileItemChildren',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
	items: AddOnTile[];
}


const searchInput = ref<string>('');
const itemsToShow = computed<AddOnTile[]>(() =>
	props.items.filter((item) => item.title.toLowerCase().includes(searchInput.value.toLowerCase()))
);

return { __sfc: true,props, searchInput, itemsToShow, InputSearchTextField, AddOnTileItem }
}

})